export const categories = [
  {
    slug: 'chun-niu-nai',
    name: '纯牛奶系列',
    description: '源自天然牧场，100%纯鲜牛奶，口感醇厚丝滑，营养丰富，是日常饮用的最佳选择。',
    icon: 'ri-drop-fill',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20white%20milk%20in%20glass%20bottle%20on%20wooden%20table%20with%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20food%20photography%2C%20soft%20shadows%2C%20warm%20natural%20tones%2C%20editorial%20style%2C%20high%20quality%20product%20shot&width=800&height=600&seq=cat-chun-01&orientation=landscape',
  },
  {
    slug: 'suan-nai',
    name: '酸奶系列',
    description: '采用优质乳酸菌发酵，口感细腻爽滑，富含益生菌，促进肠道健康，多种口味可选。',
    icon: 'ri-cup-fill',
    image: 'https://readdy.ai/api/search-image?query=Creamy%20yogurt%20in%20white%20ceramic%20bowl%20with%20fresh%20berries%20on%20top%2C%20clean%20cream%20background%2C%20minimalist%20food%20photography%2C%20soft%20natural%20light%2C%20warm%20tones%2C%20editorial%20style%2C%20high%20detail&width=800&height=600&seq=cat-suan-01&orientation=landscape',
  },
  {
    slug: 'er-tong-niu-nai',
    name: '儿童牛奶系列',
    description: '专为儿童研发的营养配方牛奶，富含钙铁锌及多种维生素，助力宝宝健康成长每一天。',
    icon: 'ri-emotion-happy-fill',
    image: 'https://readdy.ai/api/search-image?query=Cute%20milk%20carton%20with%20colorful%20playful%20design%20on%20bright%20cream%20background%2C%20minimalist%20still%20life%20photography%2C%20soft%20natural%20lighting%2C%20warm%20gentle%20tones%2C%20clean%20composition%2C%20editorial%20product%20shot&width=800&height=600&seq=cat-ertong-01&orientation=landscape',
  },
  {
    slug: 'gao-gai-nai',
    name: '高钙奶系列',
    description: '高钙配方牛奶，钙含量比普通牛奶高出30%，特别适合中老年人和需要补钙的人群。',
    icon: 'ri-heart-pulse-fill',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20white%20milk%20bottle%20on%20marble%20surface%20with%20soft%20natural%20light%2C%20minimalist%20food%20photography%2C%20cream%20background%2C%20warm%20gentle%20tones%2C%20high%20detail%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=cat-gaogai-01&orientation=landscape',
  },
  {
    slug: 'di-zhi-niu-nai',
    name: '低脂牛奶系列',
    description: '低脂高蛋白，保留牛奶原香同时减少脂肪摄入，是健身爱好者和注重身材管理人群的理想之选。',
    icon: 'ri-run-fill',
    image: 'https://readdy.ai/api/search-image?query=Light%20fresh%20milk%20in%20clear%20glass%20with%20minimal%20cream%20layer%2C%20on%20light%20wooden%20surface%2C%20cream%20background%2C%20clean%20minimalist%20food%20photography%2C%20soft%20natural%20lighting%2C%20editorial%20high%20detail%20product%20shot&width=800&height=600&seq=cat-dizhi-01&orientation=landscape',
  },
];

export const products = [
  {
    id: 1,
    categorySlug: 'chun-niu-nai',
    name: '爱威奶纯牛奶 1L装',
    description: '100%纯鲜牛奶，无添加，源自天然牧场，口感醇厚丝滑。每100ml含3.2g优质乳蛋白。',
    price: 12.8,
    originalPrice: 15.8,
    image: 'https://readdy.ai/api/search-image?query=Fresh%20white%20milk%20in%20glass%20bottle%201L%20size%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20simple%20elegant%20composition%2C%20high%20quality%20commercial%20shot&width=600&height=600&seq=prod-01&orientation=squarish',
    tag: '热销爆款',
    badge: 'hot',
  },
  {
    id: 2,
    categorySlug: 'chun-niu-nai',
    name: '爱威奶纯牛奶 250ml×12盒',
    description: '便携小包装，随时随地享受新鲜牛奶。一箱12盒，满足全家一周饮用需求。',
    price: 49.9,
    originalPrice: 59.9,
    image: 'https://readdy.ai/api/search-image?query=Box%20of%20small%20milk%20cartons%20250ml%20pack%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20product%20shot%20high%20detail&width=600&height=600&seq=prod-02&orientation=squarish',
    tag: '家庭套装',
    badge: 'family',
  },
  {
    id: 3,
    categorySlug: 'suan-nai',
    name: '爱威奶原味酸奶 200g×8杯',
    description: '经典原味酸奶，采用丹麦进口乳酸菌发酵，口感细腻爽滑，酸甜适中。',
    price: 35.8,
    originalPrice: 42.8,
    image: 'https://readdy.ai/api/search-image?query=Set%20of%20white%20yogurt%20cups%20on%20cream%20background%2C%20minimalist%20food%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20clean%20elegant%20composition%2C%20commercial%20high%20detail%20shot&width=600&height=600&seq=prod-03&orientation=squarish',
    tag: '经典之选',
    badge: 'classic',
  },
  {
    id: 4,
    categorySlug: 'suan-nai',
    name: '爱威奶草莓果粒酸奶 180g×6杯',
    description: '添加真实草莓果粒，果香浓郁，搭配丝滑酸奶，每一口都是甜蜜享受。',
    price: 29.9,
    originalPrice: 36.9,
    image: 'https://readdy.ai/api/search-image?query=Strawberry%20yogurt%20in%20white%20cup%20with%20real%20strawberry%20pieces%20visible%2C%20cream%20background%2C%20minimalist%20food%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-04&orientation=squarish',
    tag: '果味人气',
    badge: 'popular',
  },
  {
    id: 5,
    categorySlug: 'er-tong-niu-nai',
    name: '爱威奶儿童成长牛奶 125ml×20盒',
    description: '专为3-12岁儿童设计，添加DHA、钙铁锌，助力智力发育与骨骼成长。',
    price: 68.0,
    originalPrice: 78.0,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20kids%20milk%20carton%20with%20cute%20animal%20design%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20gentle%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-05&orientation=squarish',
    tag: '妈妈首选',
    badge: 'recommend',
  },
  {
    id: 6,
    categorySlug: 'er-tong-niu-nai',
    name: '爱威奶儿童酸奶 100g×12杯',
    description: '专为儿童口设计的酸甜适中酸奶，不添加人工色素和防腐剂，妈妈更放心。',
    price: 45.0,
    originalPrice: 52.0,
    image: 'https://readdy.ai/api/search-image?query=Small%20colorful%20kids%20yogurt%20cups%20with%20fun%20design%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-06&orientation=squarish',
    tag: '零添加',
    badge: 'clean',
  },
  {
    id: 7,
    categorySlug: 'gao-gai-nai',
    name: '爱威奶高钙纯牛奶 250ml×16盒',
    description: '钙含量提升30%，每100ml含120mg天然乳钙，满足每日钙质需求，强健骨骼。',
    price: 59.9,
    originalPrice: 69.9,
    image: 'https://readdy.ai/api/search-image?query=Premium%20high%20calcium%20milk%20carton%20with%20elegant%20design%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-07&orientation=squarish',
    tag: '强健骨骼',
    badge: 'health',
  },
  {
    id: 8,
    categorySlug: 'gao-gai-nai',
    name: '爱威奶高钙高铁奶 250ml×12盒',
    description: '钙铁双补配方，专为中老年人设计，同时补充钙质和铁质，营养更全面。',
    price: 65.0,
    originalPrice: 75.0,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20dark%20blue%20milk%20carton%20for%20senior%20nutrition%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-08&orientation=squarish',
    tag: '中老年专属',
    badge: 'senior',
  },
  {
    id: 9,
    categorySlug: 'di-zhi-niu-nai',
    name: '爱威奶低脂纯牛奶 1L装',
    description: '脂肪含量仅1.5%，保留牛奶原香和优质蛋白，轻盈无负担，健身好搭档。',
    price: 13.8,
    originalPrice: 16.8,
    image: 'https://readdy.ai/api/search-image?query=Light%20low%20fat%20milk%20in%20glass%20with%20subtle%20blue%20label%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-09&orientation=squarish',
    tag: '轻盈之选',
    badge: 'light',
  },
  {
    id: 10,
    categorySlug: 'di-zhi-niu-nai',
    name: '爱威奶脱脂牛奶 250ml×24盒',
    description: '0脂肪高蛋白，每100ml含3.6g优质蛋白，脂肪含量为0，极致轻盈体验。',
    price: 72.0,
    originalPrice: 82.0,
    image: 'https://readdy.ai/api/search-image?query=Slim%20white%20skim%20milk%20carton%20with%20green%20accents%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-10&orientation=squarish',
    tag: '0脂肪',
    badge: 'zero',
  },
  {
    id: 11,
    categorySlug: 'chun-niu-nai',
    name: '爱威奶有机纯牛奶 250ml×12盒',
    description: '有机牧场认证，无农药残留，无激素添加，每一滴都源自纯净自然。',
    price: 79.9,
    originalPrice: 89.9,
    image: 'https://readdy.ai/api/search-image?query=Organic%20milk%20carton%20with%20green%20leaf%20design%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-11&orientation=squarish',
    tag: '有机认证',
    badge: 'organic',
  },
  {
    id: 12,
    categorySlug: 'suan-nai',
    name: '爱威奶希腊式酸奶 150g×6杯',
    description: '传统希腊工艺，三倍浓缩，口感醇厚如奶油，蛋白质含量高达9g/100g。',
    price: 42.0,
    originalPrice: 48.0,
    image: 'https://readdy.ai/api/search-image?query=Thick%20Greek%20style%20yogurt%20in%20elegant%20white%20container%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20clean%20composition%2C%20commercial%20high%20detail&width=600&height=600&seq=prod-12&orientation=squarish',
    tag: '高蛋白',
    badge: 'protein',
  },
];